import * as React from 'react';
import './text-input.scss';

interface Props {
  inputData: (e: React.ChangeEvent<HTMLInputElement>, name: string) => void;
  onkeydown?: React.KeyboardEventHandler<HTMLInputElement>;
  label?: string;
  inputName?: string;
  value?: string;
  placeholder?: string;
  errorMessage?: string;
  disabled?: boolean;
  icon?: string;
  rightAlign?: boolean;
  maxLength?: number;
  inputType?: string;
}

const TextInput: React.ForwardRefRenderFunction<HTMLInputElement, Props> = (
  {
    inputData,
    onkeydown,
    label,
    value,
    placeholder,
    errorMessage,
    inputName,
    disabled = false,
    rightAlign = false,
    icon,
    maxLength,
    inputType = 'text',
  },
  ref,
) => {
  const selectedValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    inputData(e, inputName ?? '');
  };

  const pickClass = () => {
    let className = '';
    className = disabled ? `input__input-disabled` : `input__input`;
    className = rightAlign ? `${className} input__right-align` : `${className}`;
    return className;
  };

  return (
    <div className="text-input">
      <div className="text-label">{label}</div>
      <input
        ref={ref}
        type={inputType}
        name={inputName}
        value={value}
        placeholder={placeholder}
        onChange={selectedValue}
        onKeyDown={onkeydown}
        className={pickClass()}
        disabled={disabled ? true : false}
        maxLength={maxLength}
      />
      <div className="text-input-error">{errorMessage}</div>
    </div>
  );
};
export default React.forwardRef(TextInput);
